import React, { useEffect, useRef } from 'react';
import { Purpose, useWechatLogin } from '../auth/useWechatLogin';

import './WeChatLogin.css';

type Props = { onSuccess: (data: any) => void; onBusyChange?: (busy: boolean) => void;
  disabled?: boolean; purpose?: Purpose };
export default function WeChatLogin({ onSuccess, onBusyChange, disabled = false, purpose = 'login' }: Props) {
  
  const auth = useWechatLogin({ onSuccess, purpose,  });
  const trigger = useRef<HTMLButtonElement>(null);
  const cancelButton = useRef<HTMLButtonElement>(null);
  useEffect(() => { onBusyChange?.(auth.busy); return () => onBusyChange?.(false); }, [auth.busy, onBusyChange]);
  useEffect(() => {
    if (auth.authorizationUrl) cancelButton.current?.focus();
  }, [auth.authorizationUrl]);
  function cancel() { auth.cancel(); trigger.current?.focus(); }
  return <div className="wechat-auth" aria-live="polite">
    <button ref={trigger} type="button" className="wechat-auth__button"
      disabled={disabled || !auth.available || auth.busy} onClick={() => { void auth.start(); }}>
      {auth.busy ? (auth.phase === 'processing' ? '正在完成微信授权…' : '等待微信授权…') :
        (purpose === 'bind' ? '绑定微信' : '微信扫码登录')}
    </button>
    {!auth.available && <p className="wechat-auth__hint">{auth.configurationMessage}</p>}
    {auth.message && <p role="status" className="wechat-auth__hint">{auth.message}</p>}
    {auth.busy && !auth.authorizationUrl && <div className="wechat-auth__waiting">
      <p>{auth.seconds > 0 ? `${auth.seconds} 秒后超时` : '正在发起微信授权'}</p>
      <button type="button" onClick={cancel}>取消授权</button>
    </div>}
    {auth.authorizationUrl && <div className="wechat-auth__overlay" onClick={cancel}>
      <section className="wechat-auth__dialog" role="dialog" aria-modal="true" aria-label="微信扫码授权"
        onClick={event => event.stopPropagation()} onKeyDown={event => {
          if (event.key === 'Escape') cancel();
          if (event.key === 'Tab') {
            const nodes = event.currentTarget.querySelectorAll<HTMLElement>('button, a, iframe');
            const first = nodes[0], last = nodes[nodes.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
          }
        }}>
        <div className="wechat-auth__heading"><h3>微信扫码{purpose === 'bind' ? '绑定' : '登录'}</h3>
          <button ref={cancelButton} type="button" onClick={cancel} aria-label="关闭微信授权">关闭</button></div>
        <iframe title="微信官方登录二维码" src={auth.authorizationUrl} className="wechat-auth__frame"
          referrerPolicy="no-referrer" />
        <p>请用微信扫描二维码并确认授权</p>
        <p>{auth.seconds} 秒后过期</p>
        <a href={auth.authorizationUrl} target="_blank" rel="noopener noreferrer">无法显示二维码？打开微信授权页</a>
      </section>
    </div>}
  </div>;
}
